// src/version.ts
export const appVersion = "2.2"; 
